import React,{createContext,useCallback,useContext,useEffect,useState} from 'react';
const ShowSidebarContext = createContext();
export const ShowSidebarProvider=({children})=>{
    const desktopSidebarQuery = "(min-width: 1280px)";
    const [isDesktop,setIsDesktop]=useState(() =>
        typeof window === "undefined" ? true : window.matchMedia(desktopSidebarQuery).matches
    );
    const [showSidebar,setShowSidebar]=useState(isDesktop);

    useEffect(() => {
        const mediaQuery = window.matchMedia(desktopSidebarQuery);
        const syncSidebarWithViewport = (event) => {
            setIsDesktop(event.matches);
            setShowSidebar(event.matches);
        };

        mediaQuery.addEventListener("change", syncSidebarWithViewport);
        return () => mediaQuery.removeEventListener("change", syncSidebarWithViewport);
    }, []);
    const handleShowSidebar=useCallback(()=>{
        setShowSidebar((visible) => !visible);
    }, []);
    const closeSidebar=useCallback(() => setShowSidebar(false), []);
    return(
        <ShowSidebarContext.Provider value={{showSidebar,handleShowSidebar,closeSidebar,isDesktop}}>
            {children}
        </ShowSidebarContext.Provider>
    )
}
export  const useShowSidebar=()=>{
    return useContext(ShowSidebarContext);
}
